import { createContext } from 'react'
import { RouterContext } from 'components/router/context/RouterContextTypes'

export const routerContext = createContext<RouterContext>([])
